/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SystemManagerRowVm } from '../../../models/system-manager-row-vm';
import { GlobalConstants } from '../../../constants/global-constants';
import { SysQueContextMenuComponent } from '../../../../../../../shared/ui/src/lib/components/sysque-context-menu/sysque-context-menu.component';

@Component({
  selector: 'system-manager-row-template',
  templateUrl: './system-manager-row-template.component.html',
  styleUrls: ['./system-manager-row-template.component.scss'],
  standalone: false
})
export class SystemManagerRowTemplateComponent {
  @Input() rowVm: SystemManagerRowVm;
  @Input() isSearching: boolean;
  @Input() isChecked: boolean;
  @Input() exportClicked: boolean;
  @Input() allSystemsSelected: boolean;
  @Input() needUpwardMenu: boolean;
  @Output() checkedChange = new EventEmitter<any>();
  @Output() switchChange = new EventEmitter<string>();
  @Output() contextMenuVisibility = new EventEmitter<any>();
  @Output() deleteSystem = new EventEmitter<string>();
  @Output() renameSystem = new EventEmitter<string>();
  @Output() duplicateSystem = new EventEmitter<string>();
  @Output() setComponentPriority = new EventEmitter<string>();
  @ViewChild(SysQueContextMenuComponent) contextMenu: SysQueContextMenuComponent;

  public menuItems = [
    { label: GlobalConstants.DuplicateMenuItem, disabled: false, imageSrc: 'assets/img/Duplicate.png' },
    { label: GlobalConstants.RenameMenuItem, disabled: false, imageSrc: 'assets/img/Rename.png' },
    { label: GlobalConstants.SetComponentPriorityMenuItem, disabled: false, imageSrc: 'assets/img/SetPriority.png' },
    { label: GlobalConstants.DeleteMenuItem, disabled: false, imageSrc: 'assets/img/Delete.png' },
  ];

  /**
   * This is used only to emit the label of the row where the checkbox was checked
   * @param event - The event to be emitted
   */
  public onCheckedChange(event: any): void {
    this.checkedChange.emit({ label: this.rowVm.label, detail: event.detail });
  }

  /**
   * Emit event to switch the system
   */
  public onSwitchChange(): void {
    this.switchChange.emit(this.rowVm.label);
  }

  /**
   * Handles the context menu visibility
   */
  public handleContextMenuVisibility(): void {
    this.contextMenuVisibility.emit(this.rowVm.label);
  }

  /**
   * Handles the context menu item click
   * @param item - The item clicked
   * @param system - The system where the context menu was opened
   */
  public handleContextMenuItem(item: string, system: string): void {
    switch (item) {
      case GlobalConstants.DuplicateMenuItem:
        //Emit event to duplicate the system
        this.duplicateSystem.emit(system);
        break;
      case GlobalConstants.RenameMenuItem:
        //Emit event to rename the system
        this.renameSystem.emit(system);
        break;
      case GlobalConstants.SetComponentPriorityMenuItem:
        //Emit event to set the component priority
        this.setComponentPriority.emit(system);
        break;
      case GlobalConstants.DeleteMenuItem:
        //Emit event to delete the system
        this.deleteSystem.emit(system);
        break;
    }
  }

  /**
   * Checks if the drag is enabled to show the drag icon
   * @returns - If the drag is enabled
   */
  public isDragEnabled(): boolean {
    return !this.exportClicked && this.allSystemsSelected && this.rowVm.selected && !this.isSearching
  }
}
